(function ( $ ) {

	var Menu = {};

	Menu.hasChildren = function () {
		var svgArrowDown = '<svg viewBox="0 0 36 24" preserveAspectRatio="xMidYMid meet" aria-hidden="true"><use xlink:href="#icon--arrow-down" /></svg>';
		if ( $( ".navbar-toggle" ).is( ":visible" ) ) {
			if ( !$( ".tgcaret" ).length ) {
				$( '.menu-item-has-children' ).append( "<button type='button' class='tgcaret'>" + svgArrowDown + "</button>" );
				Menu.hasChildrenClick();
				Menu.langClick();
			}
		}
		else {
			$( ".tgcaret" ).html( svgArrowDown );
			$( ".sub-menu" ).removeAttr( 'style' );
			$( '.pll-parent-menu-item > .tgcaret' ).removeClass( 'is-up' );
			$( '.pll-parent-menu-item > .sub-menu' ).removeClass( 'is-opened' );
		}

		if ( $( '.menu-item-has-children' ).hasClass( 'pll-parent-menu-item' ) ) {
			if ( !$( ".tgcaret" ).length ) {
				$( '.menu-item-has-children' ).append( "<button type='button' class='tgcaret'>" + svgArrowDown + "</button>" );
				Menu.hasChildrenClick();
				Menu.langClick();
			}
		}
	};

	Menu.langClick = function() {
		$( '.pll-parent-menu-item > a ' ).click( function ( e ) {
			e.preventDefault();
			$( '.pll-parent-menu-item > .tgcaret' ).trigger( "click" );
		} );
	};


	Menu.hasChildrenClick = function () {
		$( '.menu-item-has-children > .tgcaret' ).click( function ( e ) {
			
			if ( $( ".navbar-toggle" ).is( ":visible" ) || $( this ).parent( ".menu-item-has-children" ).hasClass('pll-parent-menu-item')) {
				e.preventDefault();
				
				if($( this ).hasClass('is-up')) {
					$( this ).removeClass('is-up');
				}
				else {
					$( this ).addClass('is-up');
				}

				if($( this ).parent( ".menu-item-has-children" ).hasClass('pll-parent-menu-item') && !$( ".navbar-toggle" ).is( ":visible" ) ) {
					$( this ).parent( ".pll-parent-menu-item" ).children( ".sub-menu" ).toggleClass( "is-opened" );
				}
				else {
					$( this ).parent( ".menu-item-has-children" ).children( ".sub-menu" ).slideToggle( "fast" );
				}
			}
		} );
	};

	var positionOfScroll = 0;

	Menu.navScroll = function () {
		var windscroll = $( window ).scrollTop();
		var navHeight = $( '.header-nav' ).outerHeight();
		
		if(!$('.navbar').hasClass('is-open')) {
		
			if(windscroll > positionOfScroll) {
				//down
				if ( windscroll > navHeight ) {
					$( '.navbar' ).addClass('scroll-hide');
				}
				
			} else {
				//up
				var addedHeight = 122;
				if ( Viewport.documentWidth().width < 767 ) {
					addedHeight = 30;
				}

				if ( windscroll > (navHeight + addedHeight )) {
					$( '.navbar' ).removeClass('scroll-hide');
					$( '.navbar' ).addClass( 'has-bg' );
				}
				else {
					$( '.navbar' ).removeClass( 'has-bg' );
					$( '.navbar' ).removeClass('scroll-hide');
				}
			}

			positionOfScroll = windscroll;
		}
	};

	// Menu.homeChanges = function () {
	// 	$( '.navbar-toggle' ).on( 'click', function () {
	// 		if ( $( '.navbar' ).hasClass( 'mobile-bg' ) ) {
	// 			$( '.navbar' ).removeClass( 'mobile-bg' );
	// 		}
	// 		else {
	// 			$( '.navbar' ).addClass( 'mobile-bg' );
	// 		}
	// 	} );
	// };

	// Menu.homeChanges();
	Menu.hasChildren();
	$( window ).resize( function () {
		Menu.hasChildren();
	} );

	$( window ).scroll( function () {
		Menu.navScroll();
	} ).scroll();

	$( window ).ready( function(){

	// 	$('.navbar.has-bg').bind('mousewheel', function() {
	// 		return false;
	//    });

		var currentScroll = 0;

		$( '.navbar-collapse' ).on( 'shown.bs.collapse', function(){
			currentScroll = $( window ).scrollTop();
			$( '.navbar' ).addClass( 'mobile-bg' );
			
			setTimeout(function() {
				
				// $( 'body,html' ).addClass( 'lock-position' );
				$( '.navbar' ).addClass( 'is-open' );
				
				if( $( '.navbar' ).hasClass('has-bg') ) {
					$( '.navbar' ).removeClass( 'has-bg' );
					$('.navbar').addClass('present');
				}

				$(".navbar-nav").removeClass('hidden-mob');
				$(".nav-sections").removeClass('hidden-mob');
			}, 400);
		
		}).on( 'hide.bs.collapse', function(){
			$( '.navbar' ).removeClass( 'is-open' );
			// $( 'body,html' ).removeClass( 'lock-position' );
			
			setTimeout(function() {
				$( window ).scrollTop( currentScroll );

				$(".navbar-nav").addClass('hidden-mob');
				$(".nav-sections").addClass('hidden-mob');

				if( $( '.navbar' ).hasClass('present') ) {
					$( '.navbar' ).addClass( 'has-bg' );
					$('.navbar').removeClass('present');
				}

				if ( $( '.navbar' ).hasClass( 'mobile-bg' ) ) {
					$( '.navbar' ).removeClass( 'mobile-bg' );
				}
			}, 400);
		});
	});

	$( window ).on( 'resize', function(){
		if ( Viewport.documentWidth().width < 767 ) {
			$(".navbar-nav").removeAttr('style');
			$(".nav-sections").removeAttr('style');
			if($(".navbar").hasClass('is-open')) {
				$(".navbar").removeClass('is-open');
				$(".navbar").removeClass('mobile-bg');
				$("html").removeClass('lock-position');
				$("body").removeClass('lock-position');
				$(".navbar-collapse").removeClass('in');
				$(".navbar-toggle").attr("aria-expanded", false);
			}
		}
	});

})( jQuery );
